import {get} from '../utils'

export default host => (token) =>
 get(`${host}/public/contentCreations/${token}?include=translations;video.thumbnail;contentCreator;audio;binary;image;embededContent`)
    .then(response => response.json())
    .then(json => json.data)

